export enum LocalStorageKeys {
    LAST_INTERACTION_TIME = 'last-interaction-time',
    ALERT_STATE_DATA = 'alert-state-data',
    DISTRIBUTOR_KEY = 'distributorKey',
    LOAN_SERVICER_KEY = 'loanServicerKey',
    CLIENT_KEY = 'clientKey' //todo: deprecate this
}
